import React from 'react';
import { Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styles from './AnnouncementInfoModal.module.scss';

function AnnouncementInfoModal({ edit, onClose }) {
  return (
    <Modal open closeIcon size="small" centered={false} onClose={onClose}>
      <Modal.Header>{edit.title}</Modal.Header>
      <Modal.Content>
        <div className={styles.box} dangerouslySetInnerHTML={{ __html: edit.describe }} />
      </Modal.Content>
    </Modal>
  );
}
AnnouncementInfoModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  edit: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

AnnouncementInfoModal.defaultProps = {
  edit: null,
};
export default AnnouncementInfoModal;
